export default __webpack_public_path__ + "static/media/digicel-and-bmobile-logos.a442c73d.png";